import z from 'zod';
import { REGISTRATION_DETAILS_FORM_FIELDS } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/LegalPersonDetails/hook/types.ts';

export const RegistrationDetailsFormShape = z.object({
	[REGISTRATION_DETAILS_FORM_FIELDS.jurisdiction_name]: z.string().nullish(),
	[REGISTRATION_DETAILS_FORM_FIELDS.jurisdiction_language]: z.string().nullish(),
	[REGISTRATION_DETAILS_FORM_FIELDS.legal_form_id]: z.string().nullish(),
	[REGISTRATION_DETAILS_FORM_FIELDS.registration_number]: z.string().nullish(),
	[REGISTRATION_DETAILS_FORM_FIELDS.registered_name]: z
		.string()
		.min(1)
		.regex(/^\S.*$/, 'Registered name must not start with a space'),
});
